module.exports = __webpack_public_path__ + "static/avatar-0f79020ecd5ae4e951ddc837d4e37cc5.jpg";